(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("adminGroupsController", adminGroupsController);

  adminGroupsController.$inject = ["$q", "GroupsApi", "Group", "handleError"];

  function adminGroupsController($q, GroupsApi, Group, handleError) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.page = 1;
    vm.sort = "created_at";
    vm.order = "desc";
    vm.filters = {};
    vm.groups = {};
    vm.users = {};

    // methods
    vm.getGroups = getGroups;
    vm.getUsers = getUsers;
    vm.editGroup = editGroup;
    vm.createGroup = createGroup;

    function getAll() {
      getGroups().then(function () {
        return getUsers();
      });
    }

    /**
     * Retrieves adverts from the api and adds to scope
     * @return {void}
     */
    function getGroups() {
      return $q(function (resolve) {
        vm.isLoading = true;
        GroupsApi.query(
          vm.filters,
          function (response) {
            vm.groups = response;
            vm.isLoading = false;
            resolve();
          },
          function (err) {
            handleError(err);
            vm.isLoading = false;
            resolve();
          },
        );
      });
    }

    /**
     * Retrieves adverts from the api and adds to scope
     * @return {void}
     */
    function getUsers() {
      return $q(function (resolve) {
        vm.isLoading = true;
        GroupsApi.query(
          vm.filters,
          function (response) {
            vm.users = response;
            vm.isLoading = false;
            resolve();
          },
          function (err) {
            handleError(err);
            vm.isLoading = false;
            resolve();
          },
        );
      });
    }

    /**
     * Edits the category via a modal, and updates model in this controller
     * @param  {int} groupId - ID of category to edit
     * @return {void}
     */
    function editGroup(groupId) {
      Group.edit(groupId).result.then(
        function () {
          getGroups();
        },
        function (err) {
          handleError(err);
        },
      );
    }

    /**
     * Creates an advert then refreshes adverts
     * @return {void}
     */
    function createGroup() {
      Group.create().result.then(function () {
        getGroups();
      });
    }

    getAll();
  }
})(angular);
